import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bae46b8")

_pushScopeId("data-v-1bae46b8")
const _hoisted_1 = { class: "grayscale-icons" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconListItem = _resolveComponent("IconListItem")!
  const _component_IconList = _resolveComponent("IconList")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_IconList, { class: "icon-list" }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
          return (_openBlock(), _createBlock(_component_IconListItem, _mergeProps({ class: "icon-list-item" }, icon, {
            key: icon.alt
          }), null, 16))
        }), 128))
      ]),
      _: 1
    })
  ]))
})